module.exports = __webpack_public_path__ + "197bbc5d3cb0faf56aa026d40487a48b.png";